import {FeatureManager} from "@amzn/dolphin-web-framework";
import {WORKFLOW_STAGE} from "../../constants/constants";
import AppDataStore from "../app-data";

export function isStagingServiceEnabled() {
    return FeatureManager.isFeatureEnabled(FeatureManager.Features.STAGE_SERVICE_ENABLED)
        || (WORKFLOW_STAGE.SES === AppDataStore.getWorkflowStage());
}